var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 6H7.5C6.30653 6 5.16193 6.47411 4.31802 7.31802C3.47411 8.16193 3 9.30653 3 10.5V25.5C3 26.6935 3.47411 27.8381 4.31802 28.682C5.16193 29.5259 6.30653 30 7.5 30H28.5C29.6935 30 30.8381 29.5259 31.682 28.682C32.5259 27.8381 33 26.6935 33 25.5V10.5C33 9.30653 32.5259 8.16193 31.682 7.31802C30.8381 6.47411 29.6935 6 28.5 6V6ZM7.5 27C7.10218 27 6.72064 26.842 6.43934 26.5607C6.15804 26.2794 6 25.8978 6 25.5V21.87L10.95 16.935C11.2304 16.6602 11.6074 16.5062 12 16.5062C12.3926 16.5062 12.7696 16.6602 13.05 16.935L23.115 27H7.5ZM30 25.5C30 25.8978 29.842 26.2794 29.5607 26.5607C29.2794 26.842 28.8978 27 28.5 27H27.345L21.63 21.255L22.95 19.935C23.2304 19.6602 23.6074 19.5062 24 19.5062C24.3926 19.5062 24.7696 19.6602 25.05 19.935L30 24.87V25.5ZM30 20.64L27.18 17.835C26.3251 17.0137 25.1855 16.5549 24 16.5549C22.8145 16.5549 21.6749 17.0137 20.82 17.835L19.5 19.155L15.18 14.835C14.3251 14.0137 13.1855 13.5549 12 13.5549C10.8145 13.5549 9.67491 14.0137 8.82 14.835L6 17.64V10.5C6 10.1022 6.15804 9.72064 6.43934 9.43934C6.72064 9.15804 7.10218 9 7.5 9H28.5C28.8978 9 29.2794 9.15804 29.5607 9.43934C29.842 9.72064 30 10.1022 30 10.5V20.64Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.00761d3e59c23004ee1ca480b324d7df.svg";
export { ForwardRef as ReactComponent };